export const routes = {
  es: [
    { text: 'Nosotros', linkTo: 'nosotros', type: '/' },
    { text: 'Beneficios', linkTo: 'beneficios', type: '/' },
    { text: 'Servicios', linkTo: 'servicios', type: '#', showDropdown: true },
    { text: 'Core Bancario', linkTo: 'core-bancario', type: '/' },
    { text: 'Casos de uso', linkTo: 'caso-de-uso-credito', type: '/' },
    { text: 'Blog', linkTo: 'https://blog.dynamicore.io/', type: '@' }
  ],
  en: [
    { text: 'About', linkTo: 'en/about-us', type: '/' },
    { text: 'Benefits', linkTo: 'en/benefits', type: '/' },
    { text: 'Services', linkTo: 'en/services', type: '#', showDropdown: true },
    { text: 'Banking Core', linkTo: 'en/banking-core', type: '/' },
    { text: 'Use Cases', linkTo: 'en/credit-use-case', type: '/' },
    { text: 'Blog', linkTo: 'https://blog.dynamicore.io/', type: '@' }
  ]
};
